export default __webpack_public_path__ + "static/media/TryOn.4a21e246.jpg";